export default {
    computed: {
        user() {
            return this.$hub.getUser()
        }
    }
}